module.exports = __webpack_public_path__ + "static/media/gluten-free.fa2119d1.svg";